import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import { msalConfig } from "./auth/authConfig";
import LanguageWrapper from './common/features/LanguageWrapper';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { store } from './store';


const msalInstance = new PublicClientApplication(msalConfig);

let persistor = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById('root'));



root.render(
  <MsalProvider instance={msalInstance}>      
  <Provider store={store}>
    <PersistGate persistor={persistor}>
        <LanguageWrapper>
          <App />
        </LanguageWrapper>
    </PersistGate>
  </Provider>
  </MsalProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
